export enum CompartmentStatus {
  BASIC_PROD_INFO = 1,
  FEES_ND_COST = 6,
  FIN_STR_DTIL = 2,
  KEY_DT_SCHDL = 3,
  PARTIES_INVL = 4,
  DOC_ARCH = 5,
  PRD_SETUP = 7,
  SUBSCRIPTION = 8,
  ISSUED = 9,
  CASE_FREEZED = 10,
}